/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log("Container ———————— ↓");
      console.log(container);
      console.log("Variant —————————— ↓");
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log("Cart ———————————— ↓");
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    console.log("theme:cart:init");
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener("theme:scroll", (e) => {});
  document.addEventListener("theme:scroll:up", (e) => {});
  document.addEventListener("theme:scroll:down", (e) => {});

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // const readjustCurrencySelPosition = () => {
  //   let selectors = {
  //     // appWrapper: ".bacurr-cur-blocker",
  //     appBlock: ".doubly-nice-select",
  //     headerIcons: ".header__desktop__buttons.header__desktop__buttons--icons"
  //   }
  //   let appWrapper = document.querySelector(`${selectors.appBlock}`);
  //   let headerIconsRects = document.querySelector(selectors.headerIcons).getBoundingClientRect();
  //   appWrapper.style.top = `${Math.round(headerIconsRects.y)}px`;
  //   appWrapper.style.left = `${Math.round(headerIconsRects.x)}px`;
  //   appWrapper.style.transform= "translate(-100%, 48%)";
  //   appWrapper.style.width = "max-content";
  //   appWrapper.style.position = "absolute";
  //   appWrapper.style.zIndex = "10000"
  // }

  // var interval = setInterval(() => {
  //   let isApp = document.querySelector('.bacurr-cur-blocker');
  //   if(isApp != null){
  //     readjustCurrencySelPosition();
  //     clearInterval(interval)
  //   }
  // }, 1000);

  // document.addEventListener('theme:resize', e => { readjustCurrencySelPosition() });
  // document.addEventListener('theme:scroll', e => { readjustCurrencySelPosition() });

  // Custom BreadCrumbs
  var selectors_1 = {
    grandchildLink: ".navlink--grandchild",
    dropdownFamily: ".dropdown__family--grandchild",
    navlinkChild: ".navlink--child",
    firstLevelItem: ".menu__item",
    navLinkTopLevel: ".navlink--toplevel",
    navLink: ".navlink",
  };
  var classes_1 = {
    grandchildLink: "navlink--grandchild",
    dropdownFamily: "dropdown__family--grandchild",
  };

  if (theme.template.name == "index") {
    localStorage.setItem("breadcrumb", "");
  }

  document.querySelectorAll(selectors_1.navLink).forEach((navLink) =>
    navLink.addEventListener("click", (e) => {
      // e.preventDefault();
      let breadcrumb = [];
      if (!navLink.dataset.title) return;
      breadcrumb.push({
        text: navLink.dataset.title.toLowerCase(),
        url: navLink.getAttribute("href"),
      });
      if (navLink.classList.contains(classes_1.grandchildLink)) {
        let dropdownItemParent = navLink
          .closest(selectors_1.dropdownFamily)
          .querySelector(`${selectors_1.navlinkChild}:first-of-type`);
        breadcrumb.push({
          text: dropdownItemParent.dataset.title.toLowerCase(),
          url: dropdownItemParent.getAttribute("href"),
        });
      }
      let toplevelItem = navLink
        .closest(selectors_1.firstLevelItem)
        .querySelector(`${selectors_1.navLinkTopLevel}`);
      breadcrumb.push({
        text: toplevelItem.dataset.title.toLowerCase(),
        url: toplevelItem.getAttribute("href"),
      });
      breadcrumb.push({ text: "Home", url: "/" });
      localStorage.setItem("breadcrumb", JSON.stringify(breadcrumb));
    })
  );

  const breadcrumbs =
    localStorage.getItem("breadcrumb") != ""
      ? JSON.parse(localStorage.getItem("breadcrumb"))
      : null;
  const customBreadcrumbsEl = document.querySelector(
    "[data-custom-breadcrumbs]"
  );
  const isProductPage = document
    .querySelector("body")
    .classList.contains("template-product");

  if (breadcrumbs && customBreadcrumbsEl) {
    breadcrumbs.reverse();
    let breadcrumbsEls = breadcrumbs
      .map((itm) => {
        return `<span > <a href="${itm.url}"> ${itm.text} </a> </span>`;
      })
      .join(" / ");
    customBreadcrumbsEl.innerHTML = breadcrumbsEls;

    if (isProductPage) {
      customBreadcrumbsEl.innerHTML =
        customBreadcrumbsEl.innerHTML +
        " / " +
        customBreadcrumbsEl.dataset.productTitle;
    }
  }

  // Updating variant line item on variant change
  document.addEventListener("theme:variant:change", function (event) {
    // var variant = event.detail.variant;
    // var container = event.target;
    // if (variant) {
    //   if(container.querySelector('input[type="hidden"][data-sku]')){
    //     container.querySelector('input[type="hidden"][data-sku]').value = variant.sku
    //   }
    // }
  });

  const updateFilters = () => {
    if (theme.template.name != "collection") return;

    var selectors = {
      clothingJSON: "[data-clothing-json]",
      footwearJSON: "[data-footwear-json]",
      accessoryJSON: "[data-accessory-json]",
    };

    Shopify.handleize = function (str) {
      return str
        .toLowerCase()
        .replace(/[^\w\u00C0-\u024f]+/g, "-")
        .replace(/^-+|-+$/g, "");
    };

    Object.filter = (obj, predicate) =>
      Object.keys(obj)
        .filter((key) => predicate(obj[key]))
        .reduce((res, key) => ((res[key] = obj[key]), res), {});

    const flatten = (array, result = {}) => {
      array.map((itm) => {
        for (const [key, value] of Object.entries(itm)) {
          result[key]
            ? (result[key] = result[key] + value)
            : (result[key] = value);
        }
      });
      return result;
    };

    let completeJSON = JSON.parse(
      document
        .querySelector("#filter-json")
        .innerText.replaceAll("'", '"')
        .replaceAll(",]", "]")
    );
    let clothingJSON = flatten(completeJSON["clothing-sizes"]);
    let footwearJSON = flatten(completeJSON["footwear-sizes"]);
    let accessoryJSON = flatten(completeJSON["accessory-sizes"]);

    let unavailableClothing = Object.filter(
      clothingJSON,
      (quantity) => quantity == 0
    );
    let unavailableFootwear = Object.filter(
      footwearJSON,
      (quantity) => quantity == 0
    );
    let unavailableAccessory = Object.filter(
      accessoryJSON,
      (quantity) => quantity == 0
    );

    // const allFootwearSizes = document.querySelector('[data-filter-accordion="Footwear Sizes"]').querySelectorAll('input[name="filter.p.m.custom.footwear_sizes"]')
    // const allClothingSizes = document.querySelector('[data-filter-accordion="Clothing Sizes"]').querySelectorAll('input[name="filter.p.m.custom.clothing_size"]')
    // const allAccessorySizes = document.querySelector('[data-filter-accordion="Accessory Sizes"]').querySelectorAll('input[name="filter.p.m.custom.accessory_sizes"]')

    const allFootwearSizes = document.querySelectorAll(
      '[data-filter-accordion="Footwear Sizes"] input[name="filter.p.m.custom.footwear_sizes"]'
    );
    const allClothingSizes = document.querySelectorAll(
      '[data-filter-accordion="Clothing Sizes"] input[name="filter.p.m.custom.clothing_size"]'
    );
    const allAccessorySizes = document.querySelectorAll(
      '[data-filter-accordion="Accessory Sizes"] input[name="filter.p.m.custom.accessory_sizes"]'
    );

    for (const [key, value] of Object.entries(unavailableFootwear)) {
      allFootwearSizes.forEach((itm) => {
        if (Shopify.handleize(itm.value) == Shopify.handleize(key)) {
          // itm.closest('.filter__button').style.backgroundColor = "red"
          itm.closest(".filter__button").style.display = "none";
        }
      });
    }
    for (const [key, value] of Object.entries(unavailableClothing)) {
      allClothingSizes.forEach((itm) => {
        if (Shopify.handleize(itm.value) == Shopify.handleize(key)) {
          // itm.closest('.filter__button').style.backgroundColor = "red"
          itm.closest(".filter__button").style.display = "none";
        }
      });
    }

    for (const [key, value] of Object.entries(unavailableAccessory)) {
      allAccessorySizes.forEach((itm) => {
        if (Shopify.handleize(itm.value) == Shopify.handleize(key)) {
          // itm.closest('.filter__button').style.backgroundColor = "red"
          itm.closest(".filter__button").style.display = "none";
        }
      });
    }
  };
  updateFilters();

  document.addEventListener("theme:product:reloaded", (e) => updateFilters());

  class SizeListSwipers {
    constructor() {
      this.selectors = {
        sizeListSwiper: ".product-grid-item__size-list-swiper",
      };

      if (!document.querySelector(this.selectors.sizeListSwiper)) return;

      this.swiperOption = {
        slidesPerView: "auto",
      };

      this.initializeSwipers();
      this.attachEventListeners();
    }

    attachEventListeners = () => {
      document.addEventListener("theme:product:reloaded", (e) =>
        this.initializeSwipers()
      );
    };

    initializeSwipers = () => {
      const sizeListSwipers = document.querySelectorAll(
        this.selectors.sizeListSwiper
      );

      sizeListSwipers.forEach((swiper) => {
        const _navigation = {
          nextEl: `${this.selectors.sizeListSwiper}[data-product-id="${swiper.dataset.productId}"] ~ .swiper-button-next`,
          prevEl: `${this.selectors.sizeListSwiper}[data-product-id="${swiper.dataset.productId}"] ~ .swiper-button-prev`,
        };
        this.swiperOption["navigation"] = _navigation;
        new Swiper(
          `${this.selectors.sizeListSwiper}[data-product-id="${swiper.dataset.productId}"]`,
          this.swiperOption
        );
      });
    };
  }

  window.SizeListSwipers = SizeListSwipers;
  new window.SizeListSwipers();

  // (function(){
  //   const selectors = {
  //     sizeListSwiper : ".product-grid-item__size-list-swiper"
  //   }

  //   if(!document.querySelector(selectors.sizeListSwiper)) return

  //   var swiperOption = {
  //     slidesPerView: 'auto',
  //   }

  //   const initializeSwipers = () => {
  //     const sizeListSwipers = document.querySelectorAll(selectors.sizeListSwiper)

  //     sizeListSwipers.forEach(swiper => {
  //       const _navigation= {
  //         nextEl: `${selectors.sizeListSwiper}[data-product-id="${swiper.dataset.productId}"] ~ .swiper-button-next`,
  //         prevEl: `${selectors.sizeListSwiper}[data-product-id="${swiper.dataset.productId}"] ~ .swiper-button-prev`,
  //       }
  //       swiperOption["navigation"] = _navigation;
  //       console.log(swiperOption)
  //       new Swiper(`${selectors.sizeListSwiper}[data-product-id="${swiper.dataset.productId}"]`, swiperOption)
  //     })
  //   }

  //   initializeSwipers();
  //   document.addEventListener('theme:product:reloaded', e => initializeSwipers());
  //   // document.addEventListener('theme:recent-products:added', e => initializeSwipers());
  //   // document.addEventListener('theme:related-products:added', e => initializeSwipers());

  //   document.addEventListener('theme:recent-products-custom:added', e => {
  //     console.log("theme recent products added")
  //   });

  //   document.addEventListener('theme:related-products-custom:added', e => {
  //     console.log(e)
  //     console.log("theme related products added")
  //   });

  // })();

  // const updateAEDPrices = () => {
  //   const money = document.querySelectorAll('.money');
  //   console.log(money)
  //   money.forEach(targetNode => {
  //     const parent = targetNode.parentElement;
  //     if(targetNode.innerText.includes("Dhs.")){
  //       parent.classList.add("price--remove-dhs")
  //       parent.dataset.priceWithoutDhs = targetNode.innerText.replaceAll("Dhs. ", "")
  //     }
  //     else{
  //       parent.classList.remove("price--remove-dhs")
  //     }
  //   })
  // }

  // document.addEventListener('theme:cart:drawer:loaded', () => {
  //   updateAEDPrices()
  // })

  // const targetNodes = document.querySelectorAll('.money');
  // console.log(targetNodes)

  // const config = { attributes: true, childList: true };
  // // Callback function to execute when mutations are observed
  // const callback = (mutationList, observer) => {
  //   setTimeout(() => {
  //     for (const mutation of mutationList) {
  //       console.log(mutation.target)
  //       const parent = mutation.target.parentElement;
  //       console.log(parent)
  //       if(mutation.target.innerText.toLowerCase().includes("dhs.")){
  //         console.log(mutation)
  //         if (mutation.type === 'childList') {
  //           console.log('A child node has been added or removed.');
  //         } else if (mutation.type === 'attributes') {
  //           parent.classList.add("price--remove-dhs")
  //           parent.dataset.priceWithoutDhs = mutation.target.innerText.replaceAll("Dhs. ", "")
  //           parent.dataset.priceWithoutDhs = mutation.target.innerText.replaceAll("DHS. ", "")
  //           parent.dataset.priceWithoutDhs = mutation.target.innerText.replaceAll("dhs. ", "")
  //           // parent.style.setProperty('--price-without-dhs', `${mutation.target.innerText.replaceAll("Dhs. ", "")}`);
  //           // mutation.target.innerText = mutation.target.innerText.replaceAll("Dhs. ", "")
  //           console.log(`The ${mutation.attributeName} attribute was modified.`);
  //         }
  //       }
  //       else{
  //         parent.classList.remove("price--remove-dhs")
  //       }
  //     }
  //   }, 500)
  // };
  // targetNodes.forEach(targetNode => new MutationObserver(callback).observe(targetNode, config));
})();

(function () {
  const selectors = {
    drawerClose: ".upsell__modal .drawer__close",
  };

  const drawerClose = document.querySelector(selectors.drawerClose);
  console.log(drawerClose);

  drawerClose.addEventListener("click", (e) => {
    MicroModal.close();
    // drawerClose.closest(".is-open").classList.remove("is-open");
  });
})();
